import { createRouter, createWebHistory } from "vue-router";
import Home from "/src/views/Home.vue";
import Biography from "/src/views/Biography.vue";
import PersonalPhotos from "/src/views/PersonalPhotos.vue";
import MediaAndArchive from "/src/views/Archive/MediaAndArchive.vue";
import ArtWorks from "/src/views/Works/ArtWorks.vue";
import Legacy from "/src/views/Legacy/Legacy.vue";
import WorkDetails from "/src/views/Details/WorkDetails.vue";
import WritingDetails from "/src/views/Details/WritingDetails.vue";
import CollectionDetails from "/src/views/Details/CollectionDetails.vue";
import LegacyDetails from "/src/views/Details/LegacyDetails.vue";
import NotFound from '/src/views/NotFound.vue';
import Videos from "../views/Archive/Videos.vue";
import ContactUs from "../views/ContactUs.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/biography",
    name: "Biography",
    component: Biography,
  },
  {
    path: "/personalphotos",
    name: "personalPhotos",
    component: PersonalPhotos,
  },
  {
    path:'/contact',
    name:'ContactUs',
    component:ContactUs
  },

  {
    path: "/archive",
    name: "archives",
    component: MediaAndArchive,
  },
 

  {
    path: "/works",
    name: "painting",
    component: ArtWorks,
  },
  {
    path: "/legacy",
    name: "legacy",
    component: Legacy,
  },
  {
    props: true,
    path: "/workdetails/:id",
    name: "workdetails",
    component: WorkDetails,
  },
  {
    props: true,
    path: "/collectiondetails/:id",
    name: "collectiondetails",
    component: CollectionDetails,
  },
  {
    props: true,
    path: "/legacydetails/:id",
    name: "legacydetails",
    component: LegacyDetails,
  },
  {
    path: "/videos",
    name: "videos",
    component: Videos,
  },
  {
    path: "/writings/:id",
    name: "writings",
    component: WritingDetails,
    props: true,
  },
  {
    path: "/:notFound(.*)",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: () => {
    return { left: 0, top: 0 };
  },
});

export default router;
